import React from "react";
import { getAuth } from "firebase/auth";
import { AuthProvider, FirestoreProvider, useFirebaseApp, useInitFirestore } from "reactfire";
import { enableIndexedDbPersistence, initializeFirestore } from "firebase/firestore";

export interface AuthProps {}

const Auth: React.FC<AuthProps> = ({ children }) => {
	const firebaseApp = useFirebaseApp();
	const auth = getAuth(firebaseApp);
	const { status, data: firestoreInstance } = useInitFirestore(async (firebaseApp) => {
		const db = initializeFirestore(firebaseApp, {});
		return db;
	});

	if (status === "loading" || !firestoreInstance) {
		return null;
	}

	return (
		<>
			<AuthProvider sdk={auth}>
				<FirestoreProvider sdk={firestoreInstance}>{children}</FirestoreProvider>
			</AuthProvider>
		</>
	);
};

export default Auth;
